module.exports = __webpack_public_path__ + "img/pop_icon_cancle.9f086e67.svg";